/**
 * Valores iniciais do formulário de Service.
 */
export const serviceDefaults = {
    nameService: "",
    type: "service", // "service" ou "product"
    value: 0,
    allowEntries: false,
    experimentalClass: false,
    maxAmountInstallments: 1,
    stock: 0,
    costPrice: 0,
    minimumStock: 0,
    inactive: false,
    order: 0
};
